import { CorpUser } from '../../types.generated';
import { BrowseDataProductRelatedEntityType } from './BrowseDataProductTableType';

/**
 * Creates a mapping of owner names to their usernames/emails
 */
export const createOwnerEmailMapper = (owners: BrowseDataProductRelatedEntityType[]): Record<string, string> => {
    return owners.reduce(
        (acc, item) => ({
            ...acc,
            [item.name]: (item.entity as CorpUser)?.username ?? '',
        }),
        {} as Record<string, string>,
    );
};
